// extracted by mini-css-extract-plugin
export var footer = "_ok-5";
export var fulfillmentInput = "_ok-0";
export var shipDateInput = "_ok-1";
export var shipmentModal = "_ok-2";
export var shipmentModalContent = "_ok-3";
export var tableContainer = "_ok-4";